import { notify } from '../../actions/notifications';
import {
  fetchShareFolderOffers,
  IShareFolderOffersRequest,
  TShareFolderOffersResponse,
} from '../../repositories/favorites/v1/share-folder-offers';
import { ENotificationStyle } from '../../types/notifications';
import { TThunkAction } from '../../types/redux';

export const getTextForShareFolder =
  (folderId: number): TThunkAction<Promise<string | false>> =>
  async (dispatch, getState, { httpApi, logger }) => {
    const showError = () => dispatch(notify('Не удалось поделиться подборкой', ENotificationStyle.Error));

    try {
      const parameters: IShareFolderOffersRequest = { folderId };
      const { statusCode, response }: TShareFolderOffersResponse = await fetchShareFolderOffers({
        httpApi,
        parameters,
      });

      if (statusCode === 200) {
        return response.sharingText;
      }

      if (statusCode === 400) {
        showError();
        logger.warning(response.message || 'Fail to share folders offers (400 status code)');
      }
    } catch (e) {
      showError();
      logger.error(e, {
        description: 'Fail to share folders offers',
      });
    }

    return false;
  };
